var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.421 3.421L8.49119 7.33328C8.38593 7.54381 8.38593 7.54381 8.14032 7.5789L3.87716 8.19293C2.45611 8.38591 1.87716 10.1578 2.8947 11.1929L5.99997 14.228C6.1754 14.4035 6.1754 14.4035 6.14032 14.6491L5.40347 18.8947C5.15786 20.3333 6.70172 21.4561 7.96488 20.7543L11.7894 18.7368C12 18.6315 12 18.6315 12.2105 18.7368L16.0351 20.7543C17.2982 21.4561 18.8421 20.3333 18.5965 18.8947L17.8596 14.6491C17.8245 14.3859 17.8245 14.3859 18 14.228L21.1052 11.1929C22.1228 10.1578 21.5438 8.38591 20.1228 8.19293L15.8596 7.5789C15.614 7.54381 15.614 7.54381 15.5087 7.33328L13.5789 3.421C12.9122 2.15784 11.0877 2.15784 10.421 3.421Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b3c81bcc.svg";
export { ForwardRef as ReactComponent };